import * as server from '../entries/pages/search/_page.server.js';

export const index = 12;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/search/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/search/+page.server.js";
export const imports = ["_app/immutable/nodes/12.jDUN87lX.js","_app/immutable/chunks/scheduler.XyTI1WgU.js","_app/immutable/chunks/index.HYtw-Ape.js"];
export const stylesheets = ["_app/immutable/assets/12.i6FYGdFR.css"];
export const fonts = [];
